import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Medication } from "src/api/types";
import StatusBadge from "src/shared/StatusBadge";

interface Props {
  medication: Medication;
}

const MedicationStatusBadge = ({ medication }: Props) => {
  const medicationStrength = medication.medication_strength;
  const navigate = useNavigate();

  const handleNavigate = useCallback(
    (key: string) => {
      localStorage.setItem(key, "true");
      navigate(`${medication.id}`);
    },
    [medication.id, navigate],
  );

  if (medicationStrength.length === 0) {
    return (
      <StatusBadge
        status="warning"
        title="Medication Strength required. Click to update this medication"
        onNavigate={() => handleNavigate("open-medication-strength")}
      />
    );
  }

  return <StatusBadge status="success" />;
};

export default MedicationStatusBadge;
